<div class="tour-info-wrapper">
  @if (tour.sessions | session; as session) {
  <div class="tour-info">
    <div class="heading" i18n>Duration</div>
    <span class="t-medium"
      ><strong>{{ session.start | dateInterval : session.end }}</strong></span
    >
  </div>
  <div class="tour-info">
    <div class="heading" i18n>Capacity</div>
    <span class="t-medium t-large"
      ><strong>{{ session.capacity }}</strong></span
    >
  </div>
  }
  <div class="tour-info">
    <div class="heading" i18n>Acivity</div>
    <span class="t-medium t-large"
      ><strong>
        <span class="t-medium">{{ tour.theme | unTitleCase }}</span>
      </strong>
    </span>
  </div>

  <div class="tour-info">
    <div class="heading" i18n="@@country">Country</div>
    @if ( tour.address.country | country : { select: ['name', 'emoji'] } |
    async; as country ) {
    <span class="t-medium t-large"
      ><strong>
        <span>{{ country.emoji }}</span>
        {{ country.name }}</strong
      ></span
    >
    }
  </div>
</div>
